import { render, staticRenderFns } from "./EmployeeFairPayMenu.vue?vue&type=template&id=5480b75e&scoped=true"
import script from "./EmployeeFairPayMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeFairPayMenu.vue?vue&type=script&setup=true&lang=js"
import style0 from "./EmployeeFairPayMenu.vue?vue&type=style&index=0&id=5480b75e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5480b75e",
  null
  
)

export default component.exports